<template>
    <section class="section">
        <div class="container">
            <div class="columns">
                <div class="column" v-for="(chunk, name) in settings" :key="name">
                    <h2 class="title is-5">{{ name }}</h2>
                    <setting-obj v-for="setting in chunk" :key="setting.key" :setting="setting" />
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import cloneDeep from 'lodash/cloneDeep'
import sortSettings from "../../../functions/sortSettings";
import SettingObj from "../SettingObj"

export default {
    components: {
        SettingObj
    },

    computed: {
        settings() {
            return sortSettings(
                cloneDeep(this.$store.getters.settings),
                ['Danmark', 'Udlandet'],
                1
            )
        }
    },

    created() {
        this.$store.dispatch('loadSettings')
    },
}
</script>
